import { render, staticRenderFns } from "./scode.vue?vue&type=template&id=5118b2c8&"
import script from "./scode.vue?vue&type=script&lang=js&"
export * from "./scode.vue?vue&type=script&lang=js&"
import style0 from "./scode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports